import React from 'react'
import SortableColumnHeader from '../../common/SortableColumnHeader'

export const createTableHeaders = ({
  t,
  sortField,
  sortAsc,
  genderSortFieldIndex,
  lifespanSortFieldIndex,
  genderSortFields,
  lifespanSortFields,
  sortByFieldType,
}) => {
  const genderTranslationKey =
    genderSortFieldIndex >= 0 ? `tree.person.gender.${genderSortFields[genderSortFieldIndex]}` : null
  const genderLabel = genderTranslationKey ? `(${t(genderTranslationKey, '')})` : ''

  const lifespanLabel =
    lifespanSortFieldIndex >= 0
      ? t(`tree.person.lifespan.${lifespanSortFields[lifespanSortFieldIndex]}`, '')
      : t('lifespan', 'Lifespan')

  const meUserLabel = `${t('tree.column.mePersonUser', 'Me User')} / ${t('tree.starting', 'Starting')}`

  return {
    lg: {
      labels: [
        t('id', 'Id'),
        <SortableColumnHeader
          key="given-names"
          sortField={sortField}
          sortType={sortAsc ? 'ascending' : 'descending'}
          sortAsc={sortAsc}
          field="GIVEN_NAMES"
          onClick={() => sortByFieldType('GIVEN_NAMES')}
          label={t('givenName', 'Given Name')}
          block
        />,
        <SortableColumnHeader
          key="surname"
          sortField={sortField}
          sortAsc={sortAsc}
          sortType={sortAsc ? 'ascending' : 'descending'}
          field="SURNAME"
          onClick={() => sortByFieldType('SURNAME')}
          label={t('surname', 'Surname')}
          block
        />,
        <SortableColumnHeader
          key="gender"
          sortField={sortField}
          sortAsc={sortAsc}
          field="GENDER"
          sortType={genderSortFieldIndex >= 0 ? 'descending' : undefined}
          onClick={() => sortByFieldType('GENDER')}
          label={`${t('gender', 'Gender')}  ${genderLabel}`}
          block
        />,
        <SortableColumnHeader
          key="lifespan"
          sortField={sortField}
          sortType={(() => {
            if (lifespanSortFieldIndex >= 2) return undefined
            return lifespanSortFieldIndex === 0 ? 'descending' : 'ascending'
          })()}
          sortAsc={sortAsc}
          field="LIFESPAN_BEGIN"
          onClick={() => sortByFieldType('LIFESPAN_BEGIN')}
          label={lifespanLabel}
          block
        />,
        meUserLabel,
      ],
      columnWidths: [2, 2, 2, 2, 2, 2],
    },
    md: {
      labels: [t('id', 'Id'), t('tree.info.name', 'Name'), t('action.details', 'Details')],
      columnWidths: [4, 4, 4],
      combinationRules: [
        ['column1', 'column6'],
        ['column2', 'column3'],
        ['column4', 'column5'],
      ],
    },
    default: {
      labels: [t('person.label', 'Person')],
      columnWidths: [12],
      combinationRules: [['column1', 'column2', 'column3', 'column4', 'column5', 'column7']],
    },
  }
}
